import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { isAdminLoggedIn, loginAdmin } from "./adminAuth";
import "./AdminLogin.css";

const DEFAULT_ADMIN_PATH = "/admin/announcements";

function getRedirectPath(location) {
  const from = location.state?.from?.pathname || DEFAULT_ADMIN_PATH;
  return from === "/admin" ? DEFAULT_ADMIN_PATH : from;
}

function AdminLogin() {
  const location = useLocation();
  const navigate = useNavigate();
  const redirectPath = getRedirectPath(location);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (isAdminLoggedIn()) {
    return <Navigate to={redirectPath} replace />;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);

    const result = await loginAdmin(username, password);
    setSubmitting(false);
    if (!result.ok) {
      setError(result.message);
      setPassword("");
      return;
    }

    navigate(redirectPath, { replace: true });
  };

  return (
    <main id="main" className="admin-login-page container section">
      <div className="admin-login-copy">
        <p className="eyebrow">EDITORIAL &amp; ADMIN CONSOLE</p>
        <h2>
          เข้าสู่ระบบ
          <br />
          <span className="serif-accent">หลังบ้าน</span>
        </h2>
        <p>
          จัดการประกาศ อนุมัติรายการจากลูกค้า สร้างฉบับรายวัน
          <br />
          และแก้ไขเนื้อหาทุกหน้าของเว็บไซต์ได้จากที่เดียว
        </p>
        <div className="publication-note">
          <span>↳</span>
          <p>สำหรับผู้ดูแลระบบเท่านั้น · ลูกค้าที่ต้องการติดตามประกาศ ใช้หน้า &quot;ติดตามสถานะประกาศ&quot;</p>
        </div>
      </div>

      <form className="intake-card site-form admin-login-card" onSubmit={handleSubmit}>
        <p className="eyebrow">ADMIN SIGN IN</p>
        <h3>ข้อมูลผู้ดูแล</h3>
        <p className="form-intro">ใช้ชื่อผู้ใช้และรหัสผ่านที่ตั้งไว้บนเซิร์ฟเวอร์</p>

        <label>
          ชื่อผู้ใช้ <span className="required">*</span>
          <input autoComplete="username" autoFocus required value={username} onChange={(e) => setUsername(e.target.value)} />
        </label>
        <label>
          รหัสผ่าน <span className="required">*</span>
          <input autoComplete="current-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>

        {error && <p className="adm-msg err" role="alert">{error}</p>}

        <button className="button dark form-submit" type="submit" disabled={submitting}>
          {submitting ? "กำลังตรวจสอบ..." : "เข้าสู่ระบบ"}{" "}
          <span>↗</span>
        </button>
      </form>
    </main>
  );
}

export default AdminLogin;
